import { render, staticRenderFns } from "./VideosMaximizedForm.vue?vue&type=template&id=292e37ac&scoped=true"
import script from "./VideosMaximizedForm.vue?vue&type=script&lang=ts"
export * from "./VideosMaximizedForm.vue?vue&type=script&lang=ts"
import style0 from "./VideosMaximizedForm.vue?vue&type=style&index=0&id=292e37ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292e37ac",
  null
  
)

export default component.exports